var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
require('../../src/js/vendor/slick.js');

//require('slick-carousel');

/**
 * Initializes the Landing Page hero module.
 * @constructor
 * @param {Object} el - The hero element.
 */
function LandingHero(el) {
    var t = this;
    t.el = el;
    t.$el = $(el);
    t.$slideshow = t.$el.find('.js-landing-hero');
    t.$video = t.$el.find('.js-hero-video')
    t.$pause = t.$el.find('.js-hero-pause')
    t.BREAKPOINT = 850;
    t.SLIDEROFFSETSPACE = 50;
    t.PAUSED_CLASS = 'hero__play-pause--paused'
    t.$buttonPrevious = t.$el.find('.js-prev-button');
    t.$buttonNext = t.$el.find('.js-next-button');
    t.slickOptions = {
        accessibility: false,
        dots: true,
        infinite: true,
        speed: 800,
        autoplay: true,
        autoplaySpeed: 6000,
        pauseOnHover: false,
        pauseOnFocus: false,
        fade: true,
        arrows: true,
        prevArrow: t.$el.find('.js-prev-button'),
        nextArrow: t.$el.find('.js-next-button'),
        customPaging: function(slider, i) {
            return $(`<button type="button">Go to slide ${i + 1}</button>`);
        },
    };

    function maybeAppliedCustomHeight(event, slick, currentSlideIndex) {
        if ($(window).width() < t.BREAKPOINT) {
            var currentSlide = slick.$slides[currentSlideIndex],
                slideHeight = $(currentSlide).height(),
                appliedHeight = slideHeight + t.SLIDEROFFSETSPACE;
            t.$slideshow.css('height', appliedHeight + 'px');
            t.$slideshow.find('.slick-list').css('height', slideHeight + 'px');
        } else {
            t.$slideshow.css('height', 'auto');
            t.$slideshow.find('.slick-list').css('height', 'auto');
        }
    }

    if(t.$slideshow.children().length > 1) {
        t.$slideshow.on('init', function (event, slick) {
            maybeAppliedCustomHeight(event, slick, 0);
            removeLiveAria()
            playPauseHandler()
            removeAria()
        })
            .slick(t.slickOptions)
            .on('beforeChange', function () {
                removeAria();
            })
            .on('afterChange', function (event, slick, currentSlide) {
                maybeAppliedCustomHeight(event, slick, currentSlide);
                removeAria();
            });

        $(window).resize(function() {
            t.$slideshow.slick('unslick').slick(t.slickOptions);
            playPauseHandler()
        });
    }
    if (t.$video.length) {
        t.$video.each(function (index, video) {
            var $videoIframe = $(video).find('iframe');
            var originalSrc = $videoIframe[0].src;
            var $videoPlayButton = $(video).find('.js-hero-video-play');
            $videoPlayButton.on('click', function () {
                $(video).addClass('hero__video--active');
                $videoIframe[0].src += '&autoplay=1';
            });
            t.$slideshow.on('beforeChange', function () {
                $videoIframe[0].src = originalSrc;
            });
        });
    }
    function playPauseHandler() {
        if (t.$pause.length) {
            t.$pause.on('click', function () {
                $(this)
                    .toggleClass(t.PAUSED_CLASS)
                    .attr('aria-label', $(this).hasClass(t.PAUSED_CLASS) ? 'Play' : 'Pause')
                t.$slideshow.slick($(this).hasClass(t.PAUSED_CLASS) ? 'slickPause' : 'slickPlay')
                t.$slickList.attr('aria-live', $(this).hasClass(t.PAUSED_CLASS) ? 'polite' : 'off')
            })
        }
    }
    function removeLiveAria() {
        t.$slickList = t.$el.find('.slick-list')
        if (t.$slickList.length) {
            t.$slickList.removeAttr('aria-live')
        }
    }
    function removeAria() {
        t.$slickDots = t.$el.find('.slick-dots li')
        if (t.$slickDots.length) {
            t.$slickDots.removeAttr('aria-hidden').removeAttr('aria-current')
            t.$el.find('.slick-dots li button').removeAttr('aria-current')
            t.$el.find('.slick-dots li.slick-active button').attr('aria-current', true)
        }
    }
}

module.exports = LandingHero;
